import React, {Component} from 'react';
import { render } from 'react-dom';
import InfiniteCalendar from 'react-infinite-calendar';
import Modal from 'react-modal';
import moment from 'moment'
//import 'moment-timezone';
import AppointmentService from '../utils/AppointmentService.js';
import 'react-infinite-calendar/styles.css'; // only needs to be imported once

// Render the Calendar

export class DateTime extends Component {
  constructor(props) {
    super(props)
    var date = props.selectedDateTime || this.withoutTime(new Date())
    this.state = {
      date: date,
      modalIsOpen: false,
      holidays: null,
      cbuClosedDates: this.props.cbuClosedDates,
      blackoutDays:this.props.blackoutDays,
      holidayDates: [],
      upcomingHoliday: null,
      width: document.body.clientWidth,
      todayClosed: false,
      environment: localStorage.getItem('environment')
    }
    this.selectDate = this.selectDate.bind(this)
    this.saveTime = this.saveTime.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  componentDidMount(){
    window.addEventListener("resize", this.updateDimensions);
    this.Appt = new AppointmentService()
    var parentThis = this
    this.Appt.holidays()
    .then(res =>{
      if(res){
        var blackoutDays = this.state.blackoutDays
        var holidayDates = []
        var holidays = res.holidays
        var showBanner = false
        var today = new Date()
        var upcomingHoliday = null
        holidays.forEach(function(holiday) {
          var holidatDate = holiday.holiday
          var date = new Date(holidatDate.substring(0, holidatDate.length - 1))
          if(today.setHours(0,0,0,0) == date.setHours(0,0,0,0) || today.getDate()+1 == date){
            upcomingHoliday = holiday
          }
          date = moment(holiday.holiday.substring(0, 10))
          holidayDates.push(date)
        })
        this.setState({
          blackoutDays:blackoutDays,
          holidayDates: holidayDates,
          upcomingHoliday: upcomingHoliday
        })
      }
      else{
        throw new Error('Holiday resonse invalid' + res);
      }
    })
    .catch(err =>{
        throw new Error('Error retrieving Holidays' + err.message);
    })
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  closeModal(){
    this.setState({
      modalIsOpen: false
    })
  }
  selectDate = (date) => {
    if(this.props.showTime == false){
      var date = new Date(date)
      var apptDateTime = date
      this.setState({
        appointmentDateTime: apptDateTime,
        modalIsOpen: false
      })
      this.props.selectDateTime(apptDateTime)
    }
    else {
      this.setState({
        modalIsOpen: true,
        date: date,
        appointmentDateTime: null
      })
    }
  }
  withoutTime = function (date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  saveTime = (time) => {
    var date = new Date(this.state.date)
    var apptDateTime = moment(date).hour(time.mil.toString().substring(0,2)).minute(time.mil.toString().substring(2,4))
    this.setState({
      appointmentDateTime: apptDateTime,
      modalIsOpen: false
    })
    this.props.selectDateTime(apptDateTime)
  }
  render() {
    var closedDates = []
    var cbuClosedDates = this.state.cbuClosedDates
    var today = new Date()
    if(cbuClosedDates && cbuClosedDates.length > 0){
      cbuClosedDates.forEach(function(closed_day) {
        var date = new Date(closed_day.for_date)
        closedDates.push(date)
      })
    }
    const customStyles =
    this.state.width < 780 ?
    {
      content: {
        width: '100%',
        left:'0%',
        padding: '0px !important'
      }
    }:
      {
        content: {
          width: '50%',
          left:'25%',
          height: '60%',
          padding: '0px !important'
        }
      }
    var options = [
      { mil: '0800', label: '8:00am' },
      { mil: '0830', label: '8:30am' },
      { mil: '0900', label: '9:00am' },
      { mil: '0930', label: '9:30am' },
      { mil: '1000', label: '10:00am' },
      { mil: '1030', label: '10:30am' },
      { mil: '1100', label: '11:00am' },
      { mil: '1130', label: '11:30am' },
      { mil: '1200', label: '12:00pm' },
      { mil: '1230', label: '12:30pm' },
      { mil: '1300', label: '1:00pm' },
      { mil: '1330', label: '1:30pm' },
      { mil: '1400', label: '2:00pm' },
      { mil: '1430', label: '2:30pm' },
      { mil: '1500', label: '3:00pm' },
      { mil: '1530', label: '3:30pm' },
      { mil: '1600', label: '4:00pm' },
      { mil: '1630', label: '4:30pm' },
      { mil: '1730', label: '5:30pm' },
      { mil: '1800', label: '6:00pm' },
    ];

  var theme = {
    accentColor: '#448AFF',
    floatingNav: {
      background: 'rgba(56, 87, 138, 0.94)',
      chevron: '#FFA726',
      color: '#FFF',
    },
    headerColor: '#448AFF',
    selectionColor: '#559FFF',
    textColor: {
      active: '#FFF',
      default: '#333',
    },
    todayColor: '#FFA726',
      weekdayColor: '#559FFF',
    };
    var buttons = []
    var this_2 = this
    var date = new Date();
    var hour = date.getHours();
    hour = (hour < 10 ? "0" : "") + hour;
   var min  = date.getMinutes();
   min = (min < 10 ? "0" : "") + min;
   var now = hour + min
   var today = this.withoutTime(new Date())
   var appointmentDate = this.withoutTime(this.state.date)
   if(this.props.cbuCloseTime){
     var closingTime = new Date();
     closingTime.setHours(this.props.cbuCloseTime.substring(0, 2));
     closingTime.setMinutes(this.props.cbuCloseTime.substring(3, 5));
     closingTime.setSeconds(0);
     var closingTimeMil = closingTime.valueOf()
     var closingTime = new Date(closingTime - this.props.workMinutes * 60000)
     var minutes =  closingTime.getMinutes()
     if(minutes < 10){
       minutes = "0" + minutes
     }
     var closingTimeFormatted = closingTime.getHours().toString() + minutes

   }
    options.forEach(function(time, index) {
      if(((parseInt(closingTimeFormatted) >= time.mil) && time.mil>now) || (parseInt(closingTimeFormatted) >= time.mil) && appointmentDate > today){
        buttons.push(<button key={index} className="btn text-center timeButton" onClick={() => this_2.saveTime(time)}>{time.label}</button>)
      }
    })
    var disableToday = []
    if(buttons.length < 1){
      disableToday = [new Date()]
    }
    var today = new Date();
    var disable = closedDates.concat(this.state.holidayDates)
    disable = disable.concat(disableToday)
    return (
      <div className="dateContainer">
        <div className='card' style={{ marginBottom: 0 }}>
          <div className='card-header blue-background text-white text-center'>
            <h4>Preferred Date</h4>
          </div>
        </div>
      { this.state.upcomingHoliday &&
        <div className="whiteBackground">
          <h6> {this.state.upcomingHoliday.message}</h6>
        </div>
      }
        <div className="card date-card">
          <InfiniteCalendar
            width={'100%'}
            height={270}
            selected={this.state.date}
            onSelect={this.selectDate}
            disabledDays={this.state.blackoutDays}
            disabledDates= {disable}
            minDate={today}
            theme={theme}
          />
        </div>
        { (this.props.blackoutDays && this.props.blackoutDays.length > 0) &&
          <p className="text-white">Spiffy dedicates select days to partner locations.</p>
        }
        <Modal
          isOpen={this.state.modalIsOpen}
          contentLabel="Example Modal"
          style={customStyles}
          >
          <div className="card-header blue-background text-white text-center dateTimeContainer ">
            <h4>Preferred Start Time</h4>
          </div>
          {buttons}
          <button onClick = {() => this.closeModal()}className="btn btn-block text-center cancelButton">Cancel</button>
        </Modal>
      </div>
    )
  }
}
export default DateTime



// WEBPACK FOOTER //
// ./src/Components/DateTime.js